const CMS_IMAGE_BUCKET_URL = /https?:\/\/storage\.googleapis\.com\/drupal-images-[^/]+\//g;

/**
 * Content editors sometimes paste `<img>` tags with the CMS image bucket's raw absolute URL
 * directly into rich-text HTML fields (field_html_editor and similar). Rewrite them to the
 * same-origin proxy (see packages/config/src/nextjs-config.ts's rewrites and
 * config.assets.cmsImage.uriTransformEndpoint) so the bucket/tenant naming never reaches the browser.
 */
export const rewriteCmsImageUrls = (html: string): string =>
  html.replace(CMS_IMAGE_BUCKET_URL, '/cms-images/');
